import { getQueryParamValue } from 'src/lib/browser';
import { defineEnumClampFunction } from 'src/lib/enum';
import * as localData from 'src/lib/localData';
import { ROUTE_PARAMS } from 'src/routes';

/**
 * Platform Application modes
 * @readonly
 * @enum {string}
 */
export const APPLICATION_MODE = {
  default: 'default',
  infinityExtension: 'infinity_extension',
};
defineEnumClampFunction(APPLICATION_MODE, APPLICATION_MODE.default);

export const getApplicationMode = () => {
  const queryMode = getQueryParamValue(ROUTE_PARAMS.applicationMode);
  const sessionMode = localData.sessionApplicationMode.read();
  return APPLICATION_MODE.clamp(queryMode || sessionMode);
};

export const getApplicationHost = () => {
  const queryHost = getQueryParamValue(ROUTE_PARAMS.host);
  const sessionHost = localData.sessionApplicationHost.read();
  return queryHost || sessionHost || null;
};
